import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { store } from './redux/store'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

const renderApp = () => {
	root.render(
		<Provider store={store}>
			<App />
		</Provider>,
	)
}

const login = setInterval(() => {
	if ((window as any)._smartico) {
		renderApp()
		clearInterval(login)
	}
}, 10)

root.render(<>Loading...</>)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
